import { render, staticRenderFns } from "./StampTemplateEditor.vue?vue&type=template&id=d731cd96&"
import script from "./StampTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./StampTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d731cd96')) {
      api.createRecord('d731cd96', component.options)
    } else {
      api.reload('d731cd96', component.options)
    }
    module.hot.accept("./StampTemplateEditor.vue?vue&type=template&id=d731cd96&", function () {
      api.rerender('d731cd96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/shared/StampTemplateEditor.vue"
export default component.exports